/**
 * Imports only reset and body styles
 *
 */

import './dnb-ui-body.scss'
